import React, { useState, useEffect } from "react";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader, Col, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Spin } from "antd";
import { createFormulaire, getFormulaire } from "../services/formulaireApi"; // assurez-vous que cette fonction est correcte
import toast from "react-hot-toast";
import { useQuery, useQueryClient } from "react-query";

const AddTypeFormulaireForm = ({ modal, setModal, toggle, selectedCategory, isOpen }) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isTypeExist, setIsTypeExist] = useState(false); // Ajout d'état pour vérifier si le type existe
  const queryClient = useQueryClient(); 

  // Récupérer tous les formulaires avec useQuery
  const { data: formulaires, isLoading, isError } = useQuery("formulaires", getFormulaire);

  const initialValues = {
    type: "",  // Nous n'avons besoin que du type ici
    category: selectedCategory, // Utiliser la catégorie sélectionnée
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object().shape({
      type: Yup.string().required("Un type est nécessaire pour continuer."), // Validation uniquement pour le type
    }),
    onSubmit: async (values) => {
      setIsLoadingSubmit(true);
      
      // Filtrer les formulaires dans la même catégorie pour vérifier si le type existe déjà
      const formulairesInCategory = formulaires?.filter(formulaire => formulaire.category === selectedCategory);
      const typeAlreadyExists = formulairesInCategory?.some((formulaire) => formulaire.type === values.type);

      if (typeAlreadyExists) {
        setIsTypeExist(true); // Mettre à jour l'état pour indiquer que le type existe déjà
        setIsLoadingSubmit(false);
        return;
      }

      try {
        await createFormulaire({ ...values }); // Assurez-vous que la fonction d'API accepte un objet avec seulement "type" et "category"
        await queryClient.invalidateQueries("formulaires");
        toast.success("La nouvelle partie à inspecter a été ajoutée avec succès 🎉");
        toggle();  // Ferme la modal après la soumission
        formik.resetForm(); // Réinitialise le formulaire
        setIsTypeExist(false); // Réinitialise l'état après soumission réussie
      } catch (error) {
        toast.error(`Erreur: ${error?.message || error}`);
      } finally {
        setIsLoadingSubmit(false);
      }
    },
  });

  useEffect(() => {
    // Chaque fois que le formulaire change ou la catégorie est sélectionnée, on met à jour isTypeExist
    const formulairesInCategory = formulaires?.filter(formulaire => formulaire.category === selectedCategory);
    const typeAlreadyExists = formulairesInCategory?.some((formulaire) => formulaire.type === formik.values.type);
    setIsTypeExist(typeAlreadyExists);
  }, [formik.values.type, selectedCategory, formulaires]);

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{
        maxWidth: "520px",
      }}
    >
      <Form onSubmit={formik.handleSubmit}>
        <ModalHeader className="d-flex justify-content-center align-items-center p-3">
          <h3
            className="text-center"
            style={{
              color: "#252525",
              fontFamily: "Raleway",
              fontSize: "22px",
              fontWeight: "bold",
            }}
          >
            Créer une nouvelle partie à inspecter
          </h3>
          <div className="text-center categoryTitle">
            Dans une {selectedCategory}, vous pouvez créer une partie à inspecter pour le conducteur.
          </div>
        </ModalHeader>
        
        <ModalBody>
          <Row className="justify-content-center">
            <Col md={12}>
              <div className="mb-3">
                <label htmlFor="type" className="form-label" style={{ color: '#6C6B6B', fontFamily: 'Inter', fontWeight: '400px', fontSize: '14px' }}>
                  Type <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="type"
                  name="type"
                  placeholder="Veuillez renseigner un type"
                  className="form-control"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.type}
                  required
                />
                {formik.touched.type && formik.errors.type && (
                  <div className="text-danger">{formik.errors.type}</div>
                )}
                {isTypeExist && (
                  <div className="text-danger">Ce type existe déjà dans cette catégorie.</div>
                )}
              </div>
            </Col>
          </Row>
        </ModalBody>
        
        <ModalFooter>
          <Col md={12}>
            <Button
              style={{
                borderRadius: '20px',
                marginRight: '100px',
                border: '2px #151515',
                width: '100%',
              }}
              type="submit"
              className="bordered-btn"
              disabled={isLoadingSubmit || isTypeExist}
            >
              {isLoadingSubmit ? <Spin size="small" /> : "Enregistrer"}
            </Button>
          </Col>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddTypeFormulaireForm;
